import { makeObservable, observable } from 'mobx';
import { VOIState } from './modules/voi';

class State {
  @observable voi = new VOIState();

  constructor() {
    // Required for MobX 6 when using @observable decorators
    makeObservable(this);
  }
}

/** Our singleton state */
export const appState = new State();
